import { render, staticRenderFns } from "./OnboardingAccount.vue?vue&type=template&id=0183d2c9&"
import script from "./OnboardingAccount.vue?vue&type=script&lang=js&"
export * from "./OnboardingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports